<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2"><span class="mev1">Foreword</span> by Dave Gibbons</a></div>
<div class="SOM_pre"><a href="#/pre3"><span class="mev1">Introduction</span> Searching for Home</a></div>
<div class="SOM_chap"><a href="#/chap1"><span class="mev1">1</span> Demystifying Poverty</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev1">2</span> You Don't Have to Fear</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev1">3</span> Making Room in the Margins</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev1">4</span> How Much Is Enough?</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev1">5</span> Ignorance Can Be Hurtful</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev1">6</span> You Are Part of the Solution</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="mev1">7</span> Different Communities, Different Needs</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="mev1">8</span> Dignity and How to See People</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="mev1">9</span> Creating Communities</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><span class="mev1">10</span> Creating Consistent Rhythms</span></div>
<div class="SOM_appen_autre"><span href="#/appen4" title="Link target outside of Sample"><span class="mev1">Conclusion</span> <span class="mev2">Each One Matters</span></span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Questions for Reflection and Discussion</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">About Love Beyond Walls</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Praise for <i>I See You</i></span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?794af362